import React from 'react';
import { useParams } from 'react-router-dom';

import RadioBox from 'components/app/common/radioBox';

import './blockPrivate.scss';
import QueryBuilder from 'ComponentsV2/CommonComponents/QueryBuilder';

function BlockPrivate(props) {
    const { projectId } = useParams();
    const {
        privateType,
        onChangePrivateType,
        accessCriteriaValue,
        onChangeAccessCriteria,
        accessCriteriaFields,
    } = props;

    return (
        <>
            <RadioBox
                label="Visible to everyone"
                name="isPrivateType"
                value={privateType}
                onChange={(e) => {
                    onChangePrivateType(false);
                }}
                checked={privateType === false}
                doesValueNeedParsing={false}
            />
            <RadioBox
                label="Visible only to specific people"
                description={
                    'Make this content block visible only to people ' +
                    'meeting the following rules, where:'
                }
                name="isPrivateType"
                value={privateType}
                checked={privateType === true}
                onChange={(e) => {
                    onChangePrivateType(true);
                }}
                doesValueNeedParsing={false}
            >
                {accessCriteriaFields && (
                    <QueryBuilder
                        enableDefaultRuleset
                        fields={accessCriteriaFields}
                        projectId={projectId}
                        value={accessCriteriaValue}
                        onChange={(value) => onChangeAccessCriteria(value)}
                    />
                )}
            </RadioBox>
        </>
    );
}

BlockPrivate.propTypes = {};

export default BlockPrivate;
